module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTQzMiAyNzguNmE0OCA0OCAwIDAgMC00OCA0OHYzNzAuOGE0OCA0OCAwIDAgMCA4MS45IDMzLjlsMTg1LjQtMTg1LjNhNDggNDggMCAwIDAgMC02Ny45TDQ2NS45IDI5Mi43YTQ4IDQ4IDAgMCAwLTM0LTE0eiBtMTYgODYuNkw1OTQuOCA1MTIgNDQ4IDY1OC43di0yOTMuNXoiIGZpbGw9IiMwIiBwLWlkPSI5ODMiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Caret right-outlined.svg
// module id = joIm
// module chunks = 75